import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GetPromotionDetailsUseCase } from '@/core/domain/promotion-details/usecases/getPromotionsDetails.usecase';
import { PromotionDetailsResponse } from '@/core/domain/promotion-details/models/promotion-details.model';
import { catchError, of } from 'rxjs';
import { CurrentReservationService } from '@/common/services/reservation/current';
import { UrlService } from '@/common/services/url/url.service';
import _ from 'lodash';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'fe-coupon-promotions',
    templateUrl: './coupon-promotions.component.html',
})
export class CouponPromotionsComponent implements OnInit {
    public discountCode: string | null = null;

    public promotionDetails!: PromotionDetailsResponse | null;

    public origin: 'promotions' | 'landing' = 'promotions';

    constructor(
        private readonly route: ActivatedRoute,
        private readonly router: Router,
        public reservation: CurrentReservationService,
        public url: UrlService,
        private readonly getPromotionDetailsUseCase: GetPromotionDetailsUseCase,
        private readonly meta: Meta,
        private readonly titleService: Title,
    ) {}

    ngOnInit(): void {
        this.route.paramMap.subscribe((params) => {
            this.discountCode = params.get('coupon');
            if (this.discountCode) {
                this.getPromotionDetails(this.discountCode);
            }
        });
    }

    public getPromotionDetails(param: string): void {
        this.route.data.subscribe((data) => {
            this.origin = _.get(data, 'origin', 'promotions');
            let getPromotionDetailsUseCase;
            if (this.origin === 'promotions') {
                getPromotionDetailsUseCase =
                    this.getPromotionDetailsUseCase.execute(param, null);
            }
            if (this.origin === 'landing') {
                getPromotionDetailsUseCase =
                    this.getPromotionDetailsUseCase.execute(null, param);
            }
            getPromotionDetailsUseCase
                ?.pipe(
                    catchError(() => {
                        this.router.navigate([
                            this.url.format('promos-and-agreements'),
                        ]);
                        return of(null);
                    }),
                )
                .subscribe((promotionDetails) => {
                    if (this.origin === 'landing') {
                        this.discountCode = promotionDetails?.data?.promotion
                            .code as string;
                        this.meta.updateTag({
                            name: 'description',
                            content: promotionDetails?.data?.promotion
                                .metaDescription as string,
                        });
                        this.titleService.setTitle(
                            promotionDetails?.data?.promotion.title as string,
                        );
                        this.meta.updateTag({
                            name: 'title',
                            content: promotionDetails?.data?.promotion
                                .title as string,
                        });
                    }
                    this.reservation.current.discountCode = this.discountCode;
                    this.promotionDetails = promotionDetails;
                });
        });
    }
}
